var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tree-select',{attrs:{"tree-checkable":_vm.treeCheckable,"tree-default-expand-all":"","allowClear":true,"dropdownStyle":{ maxHeight: '220px', overflow: 'auto' },"treeData":_vm.currentDeptTreeData},on:{"change":_vm.onChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }